import {h, Fragment} from "preact"
import { Component } from 'preact'

export default class VariantBadge extends Component {
    shouldComponentUpdate() {
        return false
    }

    render({ url, id, variantNum, name, currentColor }) {
        return (
            <div class="product-card__footer" data-product-card-footer style="justify-content: space-between">
                <div class="product-card__colors-count" style={!variantNum && "opacity: 0; visibility: hidden"}>
                    <div class="product-card__colors-count-icon" role="presentation">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" aria-hidden="true" focusable="false">
                            <ellipse cx="10.696" cy="7.37" fill="#EE8847" rx="6.806" ry="6.804"></ellipse>
                            <ellipse cx="6.806" cy="15.147" fill="#DA9A9E" rx="6.806" ry="6.804" style="mix-blend-mode:multiply"></ellipse>
                            <ellipse cx="14.583" cy="15.147" fill="#6FBFDD" rx="6.806" ry="6.804" style="mix-blend-mode:multiply"></ellipse>
                        </svg>
                    </div>
                    <span class="product-card__colors-count-value" style="color: #535353;">Available in <span class="ns-color-count">{variantNum}</span> colors</span>
                </div>

                <wishlist-button-collection
                    data-product-handle={url.split("/products/")[1]}
                    data-variant-id={id}
                    show-icon=""
                    icon="wishlist"
                    align-self="center"
                    align-content="center"
                    aria-label={`Add ${name} in ${currentColor} to wishlist`}
                ></wishlist-button-collection>

                {/* <wishlist-button-collection
                    data-product-handle={url.split("/products/")[1]}
                    data-variant-id={id}
                    show-icon=""
                    icon="wishlist"
                    align-self="center"
                    align-content="center"
                    aria-label={`Add ${name} in ${currentColor} to wishlist`}
                >
                    <wk-button>
                        <button type="button" aria-label={`Add ${name} in ${currentColor} to wishlist`} className="wk-button wk-align-center wk-align-content-center">
                            <wk-icon className="wk-icon" icon="wishlist">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <path stroke="#ABAAAA" d="M10.619 1.998 8.578 7.403l-5.613.541c-.34 0-1.184.173-1.53.54-.408.433.51 1.262 1.02 1.622l4.082 3.243-1.53 4.865c-.511 1.622-.409 2.703 0 2.703.408 0 1.87-.72 2.55-1.081l4.082-2.162 3.571 2.162c.51.18 2.143 1.08 2.552 1.08.408 0 .17-1.8 0-2.702l-1.02-4.865 3.06-2.702c.51-.54 1.531-1.73 1.531-2.162 0-.12-1.02-.541-1.53-.541l-5.103-.54-2.04-5.406c-.17-.36-.613-1.081-1.02-1.081-.409 0-.851.72-1.021 1.081Z"></path>
                                </svg>
                            </wk-icon>
                        </button>
                    </wk-button>
                </wishlist-button-collection> */}
            </div>
        )
    }
}